export default __webpack_public_path__ + "static/media/PAFI_Materi Usulan Perubahan AD_RUPS 2021.aaa5ac99.pdf";